/* eslint-disable no-param-reassign */

import { createSlice } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import listSaga from './list';
import byIdSaga from './byId';
import { BaseState, createCRUDModel, createCRUDStates } from '../creator';
import { RootState } from '../index';
import { PaginatedResponse } from '../types';

export const moduleName = 'country';

export interface Country {
  id: number;
  name: string;
  iso3: string;
}

export interface State {
  list: BaseState<PaginatedResponse<Country>>,
  byId: BaseState<Country>,
}

const models = ['list', 'byId'];

export const defaultState: State = createCRUDStates<State>(models);

export const country = createSlice({
  name: moduleName,
  initialState: defaultState,
  reducers: createCRUDModel(models, moduleName),
});

export const { actions } = country;

export function useCountry(): State {
  return useSelector((state: RootState) => state[moduleName]);
}

export function* saga() {
  yield* listSaga();
  yield* byIdSaga();
}
